import { setProvideFeedbackForm } from 'app/redux/actions/FormsActions'
import { setTutorialsFromSteps } from 'app/redux/actions/TutorialsActions'
import {
  checkIfOrganizationsAreStale,
  getUsersOrganizationsJoinRequests
} from 'app/services/sfAuth/sfData/sfAccount'
import { enforceQuerySuccess } from 'app/services/sfAuth/sfData/sfCommon'
import { getContactsMapByFlow, setAccountOwnershipByFlow, setReviewerStatusByFlow } from 'app/services/sfAuth/sfData/sfContact'
import { getFormPage } from 'app/services/sfAuth/sfData/sfForms'
import { getExternalReviewer } from 'app/services/sfAuth/sfData/sfReviews'
import { getTutorialStepsParsed } from 'app/services/sfAuth/sfData/sfTutorial'
import { checkUserProfileValidity } from 'app/services/sfAuth/sfData/sfUser'
import MaintenanceWarningDialog from 'app/views/common/dialogs/MaintenanceWarningDialog'
import Loading from 'egret/components/EgretLoadable/Loading'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import MaintenanceScreen from '../Maintenance-screen'
import { setConfigurationData } from '../redux/actions/ConfigurationActions'
import { userLoggedIn, userLoggedOut } from '../redux/actions/LoginActions'
import {
  setAvaliableOrganizations,
  setOrganization
} from '../redux/actions/OrganizationActions'
import { setUserData } from '../redux/actions/UserActions'
import localStorageService from '../services/localStorageService'
import sfOauthConfig from '../services/sfAuth/sfAuthConfig'
import sfAuthService from '../services/sfAuth/SFAuthService'
import { mapRoles, REVIEWER } from './authRoles'
const crypto = require('crypto')

/**
 * handle login and authorization for SF
 * @component
 * @param children
 * @param maintenance disable the site completely and show a maintenance message
 * @returns {JSX.Element}
 * @constructor
 */
const Auth = ({ children, maintenance }) => {
  const history = useHistory()
  const location = useLocation()
  const pathname = location?.pathname
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const { login, user } = useSelector(state => state)
  const [networkError, setNetworkError] = React.useState()
  const isInternal = sfOauthConfig.isInternal

  const isMaintenancePeriod = moment().isBetween(maintenance?.startDate, maintenance?.endDate)

  // useBeforeunload(event => {
  //   if (user.multiuserLoginToken) {
  //     grpcGlobalLogOut({
  //       token: user.multiuserLoginToken
  //     })
  //   }
  // })

  useEffect(() => {
    const user = localStorageService.getItem('auth_user')
    dispatch(setUserData(user))
    if (!isMaintenancePeriod) {
      checkSfAuth(user)
    }
  }, [])

  // useEffect(() => {
  //   let handle
  //   if (user.multiuserLoginToken) {
  //     handle = setInterval(() => {
  //       pingServer({
  //         userId: user.userId,
  //         token: user.multiuserLoginToken,
  //         onReject: () => {
  //           console.log('global ping fail')
  //           dispatch(
  //             setUserData({
  //               ...user,
  //               multiuserAuthenticated: false
  //             })
  //           )
  //         },
  //         onSuccess: () => {
  //           console.log('global ping success')
  //         }
  //       })
  //     }, 4000)
  //   }

  //   return () => {
  //     clearInterval(handle)
  //     if (user.multiuserLoginToken) {
  //       grpcGlobalLogOut({
  //         token: user.multiuserLoginToken
  //       })
  //     }
  //   }
  // }, [user.multiuserLoginToken])

  // useEffect(() => {
  //   if (
  //     !user.multiuserAuthenticated &&
  //     user.access_token &&
  //     user.tabId &&
  //     hasRole(user.role, authRoles.tester)
  //   ) {
  //     // console.log('try login', user.access_token, user.tabId)
  //     grpcGlobalLogin({
  //       token: user.access_token,
  //       userId: user.userId,
  //       username: user.displayName,
  //       userInfo: JSON.stringify({}),
  //       browserTabId: user.tabId,
  //       onSuccess: ({ sessionToken }) => {
  //         console.log('success global login', sessionToken)
  //         dispatch(
  //           setUserData({
  //             ...user,
  //             multiuserAuthenticated: true,
  //             multiuserLoginToken: sessionToken
  //           })
  //         )
  //       },
  //       onFail: result => {
  //         console.log('failed global login', result)
  //         // dispatch(setUserData(user))
  //       }
  //     })
  //   }
  // }, [user])

  const handleDataFetchSuccess = ({ user, avaliableOrganizations, organization, configuration, tabId, state }) => {
    const { userObject, userInfo, groupMemberships } = user

    enforceQuerySuccess(() =>
      Promise.all([
        getFormPage(configuration.FORM_FEEDBACK),
        getFormPage(configuration.FORM_RESOURCE_FEEDBACK)
      ]).then(([provideFeedback, resourceFeedbackForm]) => {
        dispatch(setProvideFeedbackForm({
          provideFeedback,
          resourceFeedbackForm
        }))
      })
    )

    setAccountOwnershipByFlow(userInfo.user_id, userObject.contactId)

    const role = mapRoles(userObject.role)
    if (role.indexOf(REVIEWER) !== -1) {
      setReviewerStatusByFlow(userInfo.user_id)
    }

    if (!isInternal) {
      enforceQuerySuccess(() =>
        getUsersOrganizationsJoinRequests(user.userId)
      ).then(requests => {
        dispatch(
          setUserData({ organizationsPendingRequests: requests.length })
        )
      })
      enforceQuerySuccess(() =>
        checkUserProfileValidity(user, pathname).then(
          isValid => {
            dispatch(
              setUserData({ isUserProfileValid: Boolean(isValid) })
            )
          }
        )
      )
    }
    enforceQuerySuccess(() =>
      checkIfOrganizationsAreStale(user.userId)
    ).then(staleOrganizations => {
      dispatch(setUserData({ staleOrganizations }))
    })
    enforceQuerySuccess(() => getTutorialStepsParsed()).then(
      tutorialSteps => {
        dispatch(setTutorialsFromSteps(tutorialSteps))
      }
    )

    dispatch(setAvaliableOrganizations(avaliableOrganizations))
    dispatch(setOrganization(organization))
    dispatch(setConfigurationData(configuration))

    setLoading(false)
    dispatch(userLoggedIn())
    dispatch(setUserData({ ...user, tabId }))

    getExternalReviewer(user.userObject.contactId).then(result => {
      if (result[0]) {
        dispatch(
          setUserData({ ...user, hasExternalReviewProfile: true })
        )
      }
    })

    getContactsMapByFlow([user.userObject.contactId]).then(result => {
      const contact = Object.values(result)?.[0]
      if (contact) {
        dispatch(setUserData({
          ...user,
          contact: {
            id: contact.Id,
            whatAreYouLookingFor: contact.What_are_you_looking_for__c
          }
        }))
      } else {
        dispatch(setUserData({ ...user, contact: null }))
      }
    })

    try {
      console.log('redirect', state, history.location.pathname)
      if (
        !String(history.location.pathname).includes(
          'ApplicantInformation'
        ) ||
        // always redirect on internal, skip validity check
        isInternal
      ) {
        history.push({
          pathname: state.redirect_uri
        })
      }
    } catch (e) {
      console.error("can't redirect going to root", e, user, state)
      // window.location = '/'
    }
  }

  const checkSfAuth = user => {
    const sentState = {
      redirect_uri: location.pathname
    }
    const tabId = crypto.randomBytes(8).toString('hex')
    window.localStorage.setItem('tabId', tabId)
    // console.log('match', location, login, user, user && user.access_token)
    if (login.success) {
      console.log('user logged in')
      setLoading(false)
    } else if (user && user.access_token && user.userId) {
      console.log('got existing user session')

      sfAuthService.setUser(user)
      sfAuthService
        .checkLogin(user)
        .then(
          ({
            user,
            state,
            organization,
            configuration,
            avaliableOrganizations
          }) => {
            handleDataFetchSuccess({
              user,
              state,
              tabId,
              organization,
              configuration,
              avaliableOrganizations
            })
            sfAuthService.setUser(user)
          },
          e => {
            console.error('user check failed', e, user)
            sfAuthService.setUser(null)
            dispatch(userLoggedOut())
            sfAuthService.doLogin(sentState)
          }
        )
        .catch(e => {
          console.error('cant login from stored user', e, login)
          sfAuthService.setUser(null)
          dispatch(userLoggedOut())
          sfAuthService.doLogin(sentState)
        })
    } else {
      sfAuthService
        .parseToken()
        .then(
          ({
            user,
            state,
            organization,
            configuration,
            avaliableOrganizations
          }) => {
            handleDataFetchSuccess({
              user,
              state,
              tabId,
              organization,
              configuration,
              avaliableOrganizations
            })
          }
        )
        .catch(e => {
          console.error('cant login', e, login)
          if (e.message === 'Network Error') {
            return setNetworkError(e.message)
          }
          sfAuthService.doLogin(sentState)
        })
    }
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  if (isMaintenancePeriod) {
    return (
      <MaintenanceScreen
        startDate={moment(maintenance?.startDate).format('MMMM Do')}
        endDate={moment(maintenance?.endDate).format('MMMM Do')}
      />
    )
  }

  if (loading) {
    return <Loading atCenter />
  }

  return (
    <>
      {/* {networkError && (
        <Dialog open={true}>
          <DialogTitle>{networkError}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Trans>CONNECTION_ERROR_POP_UP_ERROR_OCURRED</Trans>
            </DialogContentText>
            <DialogContentText>
              <Trans>CONNECTION_ERROR_POP_UP_INSTRUCTIONS</Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' color='primary' onClick={handleRefresh}>
              <Trans>REFRESH</Trans>
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
      <MaintenanceWarningDialog
        dialogStartDate={maintenance?.maintenanceDialogStartDate}
        maintenanceStartDate={maintenance?.startDate}
        maintenanceEndDate={maintenance?.endDate}
        clousureStartDate={maintenance?.clousureStartDate}
      />
      {children}
    </>
  )
}

export default Auth
